import styled from 'styled-components';
import Toggle from 'react-toggle';

export const FormToggle = styled(Toggle)`

`;